import { Component, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ProjectSafetyEventFrequency, WorkSafetyEvent } from './safety.service';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/state/app.reducer';
import { selectCurrentProjectId } from 'src/app/state/app.selectors';
import { Subscription } from 'rxjs';


@Component({
    selector: 'app-safety',
    templateUrl: './safety.component.html',
    styleUrls: ['./safety.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class SafetyComponent implements OnInit, OnDestroy {
  events: WorkSafetyEvent[] = [];
  eventFrequencies: ProjectSafetyEventFrequency[] = [];
  lastEvent: WorkSafetyEvent | null = null;
  daysWithoutEvent: number | null = null;
  subscription: Subscription | undefined;

  constructor(private store: Store<AppState>) {}
  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  ngOnInit(): void {
    this.subscription =this.store.select(selectCurrentProjectId).subscribe(projectId => {
      if (projectId){

        this.loadData(projectId);
      }
    });

  }

  loadData(projectId: number): void {
    // Data loading is now handled by child components using NgRx store
  }
}
